import workspaceService from 'services/jobService';
import {
  JobAdjustmentViewer,
  PDF_TEMPLATE_ENUM,
} from 'domains/workspaceDomain';
import { Trans } from 'react-i18next';
import { RevxButton } from 'components/RevxButton';

const JobAdjustmentPDFDownloadBtn = function ({
  data,
}: {
  data: JobAdjustmentViewer;
}) {
  return (
    <RevxButton className="pdf-btn">
      <a
        target="_blank"
        rel="noreferrer"
        href={workspaceService.getPdfLink({
          jobId: data.jobId,
          template: PDF_TEMPLATE_ENUM.QUOTE,
        })}
      >
        <Trans i18nKey="jobConfig.stepViewQuote.viewPDFQuote" />
      </a>
    </RevxButton>
  );
};
export default JobAdjustmentPDFDownloadBtn;
